module.exports = __webpack_public_path__ + "img/product-31.729ec7f1.jpg";